import { usePageHeader } from "@/components/layouts/lib/page-header";
import { MailOutboxDetailDialog } from "./mail-outbox/components/MailOutboxDetailDialog";
import { MailOutboxIntro } from "./mail-outbox/components/MailOutboxIntro";
import { MailOutboxPagination } from "./mail-outbox/components/MailOutboxPagination";
import { MailOutboxTable } from "./mail-outbox/components/MailOutboxTable";
import { MailOutboxToolbar } from "./mail-outbox/components/MailOutboxToolbar";
import {
  MAIL_OUTBOX_PAGE_GUIDE,
  MAIL_OUTBOX_PAGE_SIZE,
  MAIL_OUTBOX_PAGE_TIP,
} from "./mail-outbox/mailOutboxPage.constants";
import { useMailOutboxPageActions } from "./mail-outbox/hooks/useMailOutboxPageActions";
import { useMailOutboxPageData } from "./mail-outbox/hooks/useMailOutboxPageData";
import { useMailOutboxPageState } from "./mail-outbox/hooks/useMailOutboxPageState";

export default function MailOutboxPage() {
  const pageState = useMailOutboxPageState();
  const pageData = useMailOutboxPageData({
    ...pageState.apiFilters,
    page: pageState.page,
    pageSize: MAIL_OUTBOX_PAGE_SIZE,
  });
  const actions = useMailOutboxPageActions();

  usePageHeader({
    title: "Historique des emails",
    helpTopic: "mail-outbox",
    guide: {
      steps: MAIL_OUTBOX_PAGE_GUIDE,
      tip: MAIL_OUTBOX_PAGE_TIP,
    },
  });

  return (
    <div>
      <MailOutboxIntro />
      <MailOutboxToolbar
        filters={pageState.filters}
        templateKeys={pageData.templateKeys}
        isFetching={pageData.isFetching}
        onFiltersChange={pageState.updateFilters}
        onResetFilters={pageState.resetFilters}
      />
      <MailOutboxTable
        rows={pageData.rows}
        isLoading={pageData.isLoading}
        retryingId={actions.retryingId}
        onOpenDetail={pageState.setDetailItem}
        onRetry={actions.retryEmail}
      />
      <MailOutboxPagination
        page={pageState.page}
        pageSize={MAIL_OUTBOX_PAGE_SIZE}
        total={pageData.total}
        onPageChange={pageState.setPage}
      />
      <MailOutboxDetailDialog
        item={pageState.detailItem}
        onOpenChange={(open) => {
          if (!open) pageState.setDetailItem(null);
        }}
      />
    </div>
  );
}
